import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-span-4"
}
const _hoisted_2 = {
  key: 1,
  class: "col-span-4"
}
const _hoisted_3 = {
  key: 2,
  class: "col-span-4"
}
const _hoisted_4 = {
  key: 3,
  class: "col-span-6"
}
const _hoisted_5 = {
  key: 4,
  class: "col-span-6"
}
const _hoisted_6 = {
  key: 5,
  class: "col-span-full"
}
const _hoisted_7 = { class: "col-span-full" }
const _hoisted_8 = { class: "col-span-full" }
const _hoisted_9 = { class: "col-span-full" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-12" }
const _hoisted_13 = {
  key: 6,
  class: "grid grid-cols-12 col-span-12 gap-6"
}
const _hoisted_14 = { class: "col-span-6" }
const _hoisted_15 = { class: "col-span-6" }
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = { class: "col-span-6" }
const _hoisted_18 = { class: "col-span-6" }
const _hoisted_19 = { class: "col-span-6" }
const _hoisted_20 = { class: "col-span-6" }
const _hoisted_21 = { class: "col-span-6" }
const _hoisted_22 = { class: "col-span-6" }
const _hoisted_23 = { class: "col-span-12" }
const _hoisted_24 = ["innerHTML"]

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { ref, watch, onMounted, computed } from 'vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import BookingService from '@/classes/BookingService';
import BranchService from "@/classes/Branch";
import ToggleSwitch from '@/components/inputs/ToggleSwitch.vue';
import { daysOfTheWeek } from "@/helpers/PackageRiderHelper";
import { formatter } from "@/helpers/NumberHelper";
import MobileNumber from '@/components/inputs/MobileNumber.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';

import { 
    formattedPackage,
    formattedRider,
} from '@/interfaces/CorporateBookingInterface'

import { useRouter } from 'vue-router';

const timezoneOffset = 8; // Philippines time zone is UTC+8
interface DependentInterface {
    patient_id?: string|number,
    email_address?: string,
    first_name?: string,
    middle_name?: string,
    last_name?: string,
    suffix?: string,
    sex?: string,
    birthdate?: string,
    dependent_relationship?: string,
    is_minor?: string,
    cellphone_number?: string,
    telephone_number?: string,
    civil_status?: string,
    nationality?: string,
    religion?: string,
    job_title?: string,
    birthplace?: string,
    building_number?: string,
    street?: string,
    barangay?: string,
    city?: string,
    province?: string,
    region?: string,
    zip_code?: string,
    philhealth_number?: string,
    company_name?: string,
    company_email?: string,
    company_address?: string,
    contact_person_name?: string,
    contact_person_relationship?: string,
    contact_person_number?: string,
    contact_person_email?: string,
    company_contact_no?: string,
    permanent_building_number?: string,
    permanent_street?: string,
    permanent_barangay?: string,
    permanent_city?: string,
    permanent_province?: string,
    permanent_region?: string,
    permanent_zip_code?: string,
    senior_id?: string,
    pwd_id?: string,
}

interface PatientInterface {
    first_name: string,
    middle_name?: string,
    last_name: string,
    suffix?: string,
    sex: string,
    birthdate: string,
    email_address: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    branchId: {
        type: String,
        default: null
    }
},
  setup(__props) {

const router    = useRouter();
const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)
const selectedSlot = ref(null);
const forDependent = ref(null);

const props = __props;

// const suffixes = [
//     { id: '1', label: 'Mr.', value: 'Mr.' },
//     { id: '2', label: 'Ms.', value: 'Ms.' },
//     { id: '3', label: 'Mx.', value: 'Mx.' }
// ];

const sexes = [
    { id: '1', label: 'Male', value: 'Male' },
    { id: '2', label: 'Female', value: 'Female' },
    // { id: '3', label: 'Prefer not to Say', value: 'Prefer not to Say' },
];

const packages = ref([]);
const riders = ref([]);
const selectedRiders = ref([]);
const selectedPackage = ref(null);
const riderGroups = ref([]);
const unformattedPackages = ref([]);

const selectedTime = ref(null)
const fullyBookedDates = ref([]);
const unformattedTimeSlots = ref([]);
const timeSlots = ref([]);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();
const threeDaysLater = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000 + timezoneOffset * 60 * 60 * 1000); // For 3 days advance booking

const minDate = computed(() => threeDaysLater.toISOString().slice(0, 10));
const from = ref(null);
const to = ref(null);

const selectedDateRef = ref<any>(null)
const selectedDate = ref(null)

const payload = ref<{
    is_patient_portal: boolean,
    branch_id: number,
    patient: PatientInterface,
    patient_id: any,
    dependent_patient: DependentInterface,
    package: any,
    riders: string[],
    package_id: string|null,
    package_fee: number,
    other_charges_line: any[],
    other_charges_fee: number,
    booking_date: string,
    booking_start_time: string,
    booking_end_time: string,
    branch_name: string,
    branch_address: string,
    package_name: string,
}>({
    is_patient_portal: false,
    branch_id: Number(props.branchId),
    patient: {
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix: '',
        sex: '',
        birthdate: '',
        email_address: '',
    },
    patient_id: null,
    dependent_patient: {
        patient_id: 0,
        email_address: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix: '',
        sex: '',
        birthdate: '',
        dependent_relationship: '',
        is_minor: true,
        cellphone_number: '',
        telephone_number: '',
        civil_status: '',
        nationality: '',
        religion: '',
        job_title: '',
        birthplace: '',
        building_number: '',
        street: '',
        barangay: '',
        city: '',
        province: '',
        region: '',
        zip_code: '',
        philhealth_number: '',
        company_name: '',
        company_email: '',
        company_address: '',
        contact_person_name: '',
        contact_person_relationship: '',
        contact_person_number: '',
        contact_person_email: '',
        company_contact_no: '',
        permanent_building_number: '',
        permanent_street: '',
        permanent_barangay: '',
        permanent_city: '',
        permanent_province: '',
        permanent_region: '',
        permanent_zip_code: '',
        senior_id: '',
        pwd_id: '',
    },
    package: {},
    riders: [],
    package_id: null,
    package_fee: 0,
    other_charges_line: [],
    other_charges_fee: 0,
    booking_date: '',
    booking_start_time: '',
    booking_end_time: '',
    branch_name: '',
    branch_address: '',
    package_name: '',
});

const options = [
    {
        id: 1,
        value: 'child',
        label: 'My child',
    },
    {
        id: 2,
        value: 'spouse',
        label: 'My spouse',
    },
    {
        id: 3,
        value: 'parent',
        label: 'My parent',
    },
    {
        id: 4,
        value: 'others',
        label: 'Others',
    }
]

const formatPackages = () => {
    unformattedPackages.value.forEach(unformattedPackage => {
        const formattedPackage: formattedPackage = {
            id   : null,
            label: null,
            value: null,
            disabledDates: null,
        };

        formattedPackage.id    = unformattedPackage.id;
        formattedPackage.value = unformattedPackage.id;
        formattedPackage.label = unformattedPackage.name + ' - ' + formatter.format(unformattedPackage.price);
        formattedPackage.disabledDates = unformattedPackage.disabledDates;
        packages.value.push(formattedPackage);
    });
}

const formatRiders = () => {
    riderGroups.value.forEach(riderGroup => {
        riderGroup.items.forEach(unformattedRider => {
            const formattedRider: formattedRider = {
                id   : null,
                label: null,
                value: null,
                disabledDates: null,
                name: null,
            };
    
            formattedRider.id    = unformattedRider.item_id;
            formattedRider.value = unformattedRider.item_id;
            formattedRider.label = unformattedRider.item_name + ' - ' + formatter.format(unformattedRider.item_price);
            formattedRider.disabledDates = unformattedRider.disabledDates;
            formattedRider.name = unformattedRider.item_name;

            riders.value.push(formattedRider);
        });
    });
}

const isEmailValid = () => {
    const reg = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    
    if(forDependent.value) {
        return reg.test(payload.value.dependent_patient.email_address) ? true : false;
    } else {
        return reg.test(payload.value.patient.email_address) ? true : false;
    }
}

const fetchPackagesAndRiders = () => {
    loader.value = true

    BookingService.getPackagesAndRiders()
        .then((result: any) => {
            unformattedPackages.value = result.data.packageResponse;
            
            const services = result.data.serviceResponse;
            const allergyTests = result.data.allergyTestResponse;
            riderGroups.value = services.concat(allergyTests);
            
            formatPackages();
            formatRiders();
            
            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const fetchDateAndTime = () => {
    if(selectedDate.value){
        loader.value = true
    
        const data = {
            branch_id: payload.value.branch_id,
            selected_date: selectedDate.value,
            from: from.value,
            to: to.value,
            package: payload.value.package_name,
            riders: payload.value.riders,
        }
    
        BookingService.fetchDateAndTime(data)
            .then((result: any) => {
                loader.value = false;
    
                timeSlots.value = result.data.response
                fullyBookedDates.value = result.data.response.fully_booked_dates;
            })
            .catch((error) => {

                loader.value = false;
                showError.value = true;
                errorMsg.value = error.response?.data?.message;
    
                if(error.response.status == 401) {
                    window.location.replace('/login')
                }

                if(error.response.status == 403) {
                    errorMsg.value = "You don't permission to view to page";
                }
            })
    } else {
        timeSlots.value = [];
    }
}

const updateMonth = (val:any = null) => {
    console.log(val)
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch fetchDateAndTime for Active Month
    fetchDateAndTime();
}


const firstDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}

const submitSoftBooking = () => {
    if(!isEmailValid()) {
        showError.value = true;
        errorMsg.value = "Please input a valid email address";

        return false;
    }

    loader.value = true;

    payload.value.booking_date = new Date(selectedDate.value).toISOString().split('T')[0];
    payload.value.is_dependent = forDependent.value ?? false;

    BookingService.submitSoftBooking(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;
                clearFields();
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const clearFields = () => {
    payload.value.is_patient_portal = false;
    payload.value.patient = {};
    payload.value.package = {};
    payload.value.riders = [];
    payload.value.package_id = null;
    payload.value.package_fee = null;
    payload.value.other_charges_line = [];
    payload.value.other_charges_fee = null;
    payload.value.booking_date = null;
    payload.value.booking_start_time = null;
    payload.value.booking_end_time = null;

    selectedRiders.value = [];
    selectedPackage.value = null;
    selectedDate.value = null;
    selectedTime.value = null;
    selectedSlot.value = [];

    selectedDateRef.value?.datePicker.clearValue()
}

const pushRiderInPayload = (filteredRiders) => {
    let riderPrice = 0;
    const rider_item_ids:string[] = [];
    const rider_names:string[] = [];
    filteredRiders.forEach(rider => {
        const formattedRider = {
            item_id: null,
            item_name: null,
            price: null,
        };

        formattedRider.item_id = rider.item_id;
        formattedRider.item_name = rider.item_name;
        formattedRider.price = rider.item_price;
        riderPrice += rider.item_price;
        payload.value.other_charges_line.push(formattedRider);

        rider_item_ids.push(formattedRider.item_id)
    });

    payload.value.other_charges_fee = riderPrice;

    riderGroups.value.forEach(rider => {
        const item = rider.items.filter(obj => rider_item_ids.includes(obj.item_id));
        if(item.length > 0) {
            item.forEach(a => {
                rider_names.push(a.item_name);
            });
        }
    });

    payload.value.riders = rider_names;
}

const selectRiders = (val) => {
    payload.value.other_charges_line = [];

    let filteredRiders = [];

    riderGroups.value.forEach(rider => {
        filteredRiders = filteredRiders.concat(rider.items.filter(filteredRider => val.includes(filteredRider.item_id)));
    });
    
    pushRiderInPayload(filteredRiders);
}

const clearPackagePayload = () => {
    payload.value.package_fee = null;
    payload.value.package_id = null;
}

const selectPackage = (packageId) => {
    clearPackagePayload();

    const filteredPackage = unformattedPackages.value.filter(unformattedPackage => packageId == unformattedPackage.id);
    payload.value.package = filteredPackage[0];
    payload.value.package_id = filteredPackage[0]?.id;
    payload.value.package_fee = filteredPackage[0]?.price;
    payload.value.package_name = filteredPackage[0]?.name;
}

const selectTimeSlot = (val) => {
    if(val) {
        console.log(val);
        payload.value.booking_start_time = val.split('-')[0];
        payload.value.booking_end_time = val.split('-')[1];
    }
}

const fetchBranch = async () => {
    try {
        loader.value = true;
        const response = await BranchService.editBranch(props.branchId)
        loader.value = false;
        const branchResponse = response.data.branch;
        
        if(branchResponse) {
            payload.value.branch_name = branchResponse.name;
            payload.value.branch_address = branchResponse.address_line;
        }
    }
    catch(error: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;
    }
}

const setStartEndTime = (value:string) => {
    if(value){
        const [start, end] = value.split('-');
    
        payload.value.booking_start_time = stringToTime(start);
        payload.value.booking_end_time = stringToTime(end);
    }
}


const getDisabledDates = computed<number[]>(():number[] => {
    let disabledDates:number[] = [];
    
    if(payload.value.package_id){
        const index = packages.value.findIndex( item => item.id == payload.value.package_id );
        
        disabledDates = [...new Set([...disabledDates, ...packages.value[index].disabledDates])]
    }

    if(payload.value.riders){

        payload.value.riders.forEach(rider => {
            const index = riders.value.findIndex(item => item.name == rider);
            disabledDates = [...new Set([...disabledDates, ...riders.value[index].disabledDates])]
        });
    }

    return disabledDates;
});

// This function takes a string in the format of "h:mm AM/PM" and returns a string in the format of "hh:mm:ss"
const stringToTime = (str:string): string => {
    // Split the string by space and colon
    const time:string[] = str.split(/[: ]/);
    // Convert hour and minute to numbers
    let hour:number = parseInt(time[0]);
    const minute:number = parseInt(time[1]);
    const period:string = time[2];
    // Check if the period is valid
    if (period !== "AM" && period !== "PM") {
        return "Invalid period";
    }
    // Check if the hour and minute are valid
    if (hour < 1 || hour > 12 || minute < 0 || minute > 59) {
        return "Invalid time";
    }
    // Convert hour to 24-hour format
    if (period === "PM" && hour < 12) {
        hour += 12;
    }
    if (period === "AM" && hour === 12) {
        hour = 0;
    }
    // Pad hour and minute with zeros if needed
    const newHour:string = hour.toString().padStart(2, "0");
    const newMinute:string = minute.toString().padStart(2, "0");
    // Return the time in the format of "hh:mm:ss"
    return `${newHour}:${newMinute}:00`;
}

const redirectToCompanyIndex = () => {
    showSuccess.value = false;
    router.push(`/branches/${props.branchId}/bookings/`);
}

const resetDateTime = (): void => {
    selectedDate.value = null;
    selectedSlot.value = null;

    selectedDateRef.value?.datePicker.clearValue()
    
    fetchDateAndTime()
} 

watch(
    () => selectedRiders.value,
    (val) => {
        if (val) {
            selectRiders(val);
        }
    
        resetDateTime()
    },
    { immediate: true }
);

watch(
    () => selectedPackage.value,
    (val) => {
        if(val){
            selectPackage(val);
        } else {
            payload.value.package = null;
            payload.value.package_id = null;
            payload.value.package_fee = 0;
            payload.value.package_name = '';
        }

        resetDateTime()
    },
    { immediate: true }
);

watch(
    () => selectedTime.value,
    (val) => {
        if(val)
        selectTimeSlot(val);
    },
    { immediate: true }
);

// watch(
//     () => selectedDate.value,
//     (val) => {
//         if(val)
//             selectedTime.value = null;
//             payload.value.booking_date = new Date(selectedDate.value).toISOString().split('T')[0];
//             updateMonth();
//     },
//     { immediate: true }
// );


watch(
    () => selectedDate.value,
    (val) => {
        if(val){      
            const selectedDate = new Date(val);
    
            updateMonth({
                year: selectedDate.getFullYear(),
                month: selectedDate.getMonth()
            })
        }
    },
    { immediate: true }
);

onMounted(() => {
    fetchPackagesAndRiders();
    fetchBranch();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormSection, null, {
      title: _withCtx(() => [...(_cache[29] || (_cache[29] = [
        _createTextVNode(" Individual Booking Information ", -1)
      ]))]),
      description: _withCtx(() => [...(_cache[30] || (_cache[30] = [
        _createTextVNode(" Relevant data and other details ", -1)
      ]))]),
      form: _withCtx(() => [
        (!forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(TextInput, {
                modelValue: payload.value.patient.first_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.patient.first_name) = $event)),
                id: "first_name",
                name: "first_name",
                label: "First Name",
                placeholder: "First Name",
                error: errors.value['patient.first_name'] ? errors.value['patient.first_name'][0] : ''
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        (!forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(TextInput, {
                modelValue: payload.value.patient.middle_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.patient.middle_name) = $event)),
                id: "middle_name",
                name: "middle_name",
                label: "Middle Name",
                placeholder: "Middle Name",
                error: errors.value['patient.middle_name'] ? errors.value['patient.middle_name'][0] : ''
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        (!forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(TextInput, {
                modelValue: payload.value.patient.last_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.patient.last_name) = $event)),
                id: "last_name",
                name: "last_name",
                label: "Last Name",
                placeholder: "Last Name",
                error: errors.value['patient.last_name'] ? errors.value['patient.last_name'][0] : ''
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        (!forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(MultiselectInput, {
                modelValue: payload.value.patient.sex,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.patient.sex) = $event)),
                id: "sex",
                name: "sex",
                label: "Sex",
                placeholder: "Sex",
                options: sexes,
                error: errors.value['patient.sex'] ? errors.value['patient.sex'][0] : ''
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        (!forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(DatePicker, {
                modelValue: payload.value.patient.birthdate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.patient.birthdate) = $event)),
                id: "birthdate",
                name: "birthdate",
                label: "Birthday",
                placeholder: "MM/DD/YYYY",
                error: errors.value['patient.birthdate'] ? errors.value['patient.birthdate'][0] : ''
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        (!forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(TextInput, {
                modelValue: payload.value.patient.email_address,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.patient.email_address) = $event)),
                id: "email_address",
                name: "email_address",
                label: "Patient Email",
                placeholder: "Patient Email",
                error: errors.value['patient.email_address'] ? errors.value['patient.email_address'][0] : ''
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            modelValue: payload.value.branch_name,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.branch_name) = $event)),
            id: "branch",
            name: "branch",
            label: "Branch",
            placeholder: "Branch",
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(MultiselectInput, {
            modelValue: selectedPackage.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedPackage).value = $event)),
            id: "selectedPackage",
            name: "selectedPackage",
            label: "Package",
            placeholder: "Package",
            searchable: "",
            options: packages.value,
            error: errors.value['package_id'] ? errors.value['package_id'][0] : ''
          }, null, 8, ["modelValue", "options", "error"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(MultiselectInput, {
            modelValue: selectedRiders.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedRiders).value = $event)),
            id: "selectedRiders",
            name: "selectedRiders",
            label: "Rider/s",
            placeholder: "Rider/s",
            mode: "tags",
            "close-on-select": false,
            searchable: "",
            options: riders.value,
            error: errors.value['riders'] ? errors.value['riders'][0] : ''
          }, null, 8, ["modelValue", "options", "error"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(DatePicker, {
            disabled: !selectedPackage.value && selectedRiders.value.length == 0,
            ref_key: "selectedDateRef",
            ref: selectedDateRef,
            modelValue: selectedDate.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedDate).value = $event)),
            id: "selectedDate",
            name: "selectedDate",
            label: "Booking Date",
            placeholder: "MM/DD/YYYY",
            "min-date": _unref(currentDate),
            "fully-booked-dates": fullyBookedDates.value,
            "hide-offset-dates": "",
            "highlight-disabled-days": "",
            onUpdateMonth: updateMonth,
            disabledWeekDays: getDisabledDates.value,
            error: errors.value['booking_date'] ? errors.value['booking_date'][0] : ''
          }, null, 8, ["disabled", "modelValue", "min-date", "fully-booked-dates", "disabledWeekDays", "error"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(MultiselectInput, {
            disabled: !selectedDate.value,
            modelValue: selectedSlot.value,
            "onUpdate:modelValue": [
              _cache[10] || (_cache[10] = ($event: any) => ((selectedSlot).value = $event)),
              setStartEndTime
            ],
            id: "selectedSlot",
            name: "selectedSlot",
            label: "Time Slots",
            placeholder: "Time Slots",
            searchable: "",
            options: timeSlots.value,
            error: errors.value['booking_start_time'] ? errors.value['booking_start_time'][0] : ''
          }, null, 8, ["disabled", "modelValue", "options", "error"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(ToggleSwitch, {
            value: forDependent.value,
            onChange: _cache[11] || (_cache[11] = 
                    (value) =>
                        (forDependent.value = value)
                    ),
            label: "Dependent Booking"
          }, null, 8, ["value"])
        ]),
        (forDependent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(TextInput, {
                  modelValue: payload.value.patient_id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((payload.value.patient_id) = $event)),
                  id: "patient_id",
                  name: "patient_id",
                  label: "Main Patient ID",
                  placeholder: "Main Patient ID",
                  error: errors.value.patient_id ? errors.value.patient_id[0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(TextInput, {
                  modelValue: payload.value.dependent_patient.first_name,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((payload.value.dependent_patient.first_name) = $event)),
                  id: "first_name",
                  name: "first_name",
                  label: "First Name",
                  placeholder: "First Name",
                  error: errors.value['dependent_patient.first_name'] ? errors.value['dependent_patient.first_name'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(TextInput, {
                  modelValue: payload.value.dependent_patient.middle_name,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((payload.value.dependent_patient.middle_name) = $event)),
                  id: "middle_name",
                  name: "middle_name",
                  label: "Middle Name",
                  placeholder: "Middle Name",
                  error: errors.value['dependent_patient.middle_name'] ? errors.value['dependent_patient.middle_name'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(TextInput, {
                  modelValue: payload.value.dependent_patient.last_name,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((payload.value.dependent_patient.last_name) = $event)),
                  id: "last_name",
                  name: "last_name",
                  label: "Last Name",
                  placeholder: "Last Name",
                  error: errors.value['dependent_patient.last_name'] ? errors.value['dependent_patient.last_name'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(MultiselectInput, {
                  modelValue: payload.value.dependent_patient.sex,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((payload.value.dependent_patient.sex) = $event)),
                  id: "sex",
                  name: "sex",
                  label: "Sex",
                  placeholder: "Sex",
                  options: sexes,
                  error: errors.value['dependent_patient.sex'] ? errors.value['dependent_patient.sex'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(DatePicker, {
                  modelValue: payload.value.dependent_patient.birthdate,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((payload.value.dependent_patient.birthdate) = $event)),
                  id: "birthdate",
                  name: "birthdate",
                  label: "Birthday",
                  placeholder: "MM/DD/YYYY",
                  error: errors.value['dependent_patient.birthdate'] ? errors.value['dependent_patient.birthdate'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(MobileNumber, {
                  modelValue: payload.value.dependent_patient.cellphone_number,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((payload.value.dependent_patient.cellphone_number) = $event)),
                  id: "cellphone_number",
                  name: "cellphone_number",
                  label: "Mobile Number",
                  placeholder: "Mobile Number",
                  error: errors.value['dependent_patient.cellphone_number'] ? errors.value['dependent_patient.cellphone_number'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(TextInput, {
                  modelValue: payload.value.dependent_patient.telephone_number,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((payload.value.dependent_patient.telephone_number) = $event)),
                  id: "telephone_number",
                  name: "telephone_number",
                  label: "Telephone Number",
                  placeholder: "Telephone Number",
                  error: errors.value['dependent_patient.telephone_number'] ? errors.value['dependent_patient.telephone_number'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(TextInput, {
                  modelValue: payload.value.dependent_patient.email_address,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((payload.value.dependent_patient.email_address) = $event)),
                  id: "email_address",
                  name: "email_address",
                  label: "Email Address",
                  placeholder: "Email Address",
                  error: errors.value['dependent_patient.email_address'] ? errors.value['dependent_patient.email_address'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(MultiselectInput, {
                  modelValue: payload.value.dependent_patient.dependent_relationship,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((payload.value.dependent_patient.dependent_relationship) = $event)),
                  id: "Owner Relationship",
                  name: "Owner Relationship",
                  label: "Account Owner Relationship?",
                  placeholder: "Owner Relationship?",
                  options: options,
                  error: errors.value['dependent_patient.dependent_relationship'] ? errors.value['dependent_patient.dependent_relationship'][0] : ''
                }, null, 8, ["modelValue", "error"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      actions: _withCtx(() => [
        (_ctx.$hasPermission('soft-book-dates-for-individual-patient'))
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              disabled: loader.value,
              onClick: _cache[22] || (_cache[22] = ($event: any) => (showConfirmation.value = true))
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode(" Submit ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[24] || (_cache[24] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("p", { innerHTML: errorMsg.value }, null, 8, _hoisted_24)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onCancel: _cache[25] || (_cache[25] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[26] || (_cache[26] = ($event: any) => (redirectToCompanyIndex())),
      "action-text": "Confirm",
      title: "Booking Submitted!",
      content: "Booking has been submitted successfully"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: showConfirmation.value,
      onCancel: _cache[27] || (_cache[27] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[28] || (_cache[28] = ($event: any) => {showConfirmation.value = false; submitSoftBooking() }),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Submit Booking?",
      content: "Are you sure you wish to submit this booking?"
    }, null, 8, ["show"])
  ], 64))
}
}

})